var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"copy-image",class:[_vm.id],attrs:{"data-clipboard-text":_vm.text,"src":_vm.icon,"title":"Copy GitHub Markdown"}}),(_vm.isCopied)?_c('div',{staticClass:"copied-text"},[_vm._v("Copied!")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }